<template>
<!-- 配送先リスト -->
    <b-modal v-model="showFlg"
        size="lg"
        header-bg-variant="light"
        :title="modalTitle" 
        no-close-on-backdrop
        :modal-class="'setHeight211'"
        @hide ="handleCancel">
        <b-container>
            <!-- お届け先を選択してください。 -->
            <div v-if="this.listType=='1'">{{$t('cc211.labels.note1')}}</div>
            <div v-else>{{$t('cc211.labels.note')}}</div>
            <div class="input-group mb-3 input-group-sm">
                <div class="input-group-prepend">
                    <!-- お名前： -->
                    <span class="input-group-text">{{$t('cc211.labels.name')}}</span>
                </div>
                <input-check  class="form-control mutli" v-model="cc211SearchTdkList.tdkName" maxlength="70"/>
            </div>            
        </b-container>
        <div class="container">
            <!-- 上記の名前で絞込み -->
            <b-btn size="sm" class="w-4 text-center right" variant="secondary" @click="search()">
                {{$t('cc211.buttons.search')}}
            </b-btn>
        </div>
        <div class="container pt15 clearBoth" style="height:270px">
            <data-table v-if="isDisplay"
            :data="urlSearch" 
            :requestSearch ="requestSearch"
            :columnsTable="columnsTable"
            :pageID="pageID"
            :maxHeight ="200"
            />
        </div>
        <div slot="modal-footer">
            <b-btn size="sm" class="w-4 text-center btn-sm" variant="secondary" @click="showFlg = false">
                {{$t('common.buttons.close')}}
            </b-btn>
        </div>
    </b-modal>
</template>

<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import InputCheck from 'components/InputCheck';
import DataTable from "components/Datatable";
import EventBus from 'assets/js/eventBus';
import $ from 'jquery';
export default {
    /* 
    * Name of component
    */
    name: "CC211SearchTdkList",
    /* 
    * Declare components
    */
    components: {
        InputCheck,
        DataTable,
    },/* 
    * Declare variable and set default value
    */
    props:['propKokyakuNo','propTdkKbn','listType'],
    data() {
        return {
            pageID:'cc211',
            kokyakuNo:this.propKokyakuNo,
            tdkKbn:this.propTdkKbn,
            requestSearch: {},
            columnsTable: [
                {
                    //お名前
                    'label': this.$i18n.t('sh030.labels.name'),
                    'field': 'TDK_NM_D',
                    'sort': 'asc&desc',
                    'width': 100,
                    'style': 'text-left',
                    'link': true
                },
                {
                    //ご住所
                    'label': this.$i18n.t('common.labels.address'),
                    'field': 'ADDRESS_D',
                    'sort': 'asc&desc',
                    'width': 300,
                    'style': 'text-left'
                }
            ],
            urlSearch: this.$UrlConstants.POPUP +this.$UrlConstants.CC211 +this.$UrlConstants.DO_SEARCH,
            pageNo:1,
            pageSize:30,
            isDisplay:false,
            showFlg:true,
            cc211SearchTdkList:{
                tdkName:null,
                kokyakuNo:this.propKokyakuNo,
                tdkKbn:this.propTdkKbn
            }
        }
    },
    /* 
    * Initialize
    */
    mounted(){
        var _this = this;
        //console.log('this.listType:'+this.listType);
        //Save pageNo and pageSize
        EventBus.$on('page-info', function (pageNo, pageSize) {
            _this.pageNo =  pageNo;
            _this.pageSize = pageSize;
        });
        _this.search();
        //Reload data request model
        EventBus.$on('reset-page', function () {
            _this.requestSearch = $.extend({}, _this.cc211SearchTdkList);
        });
       // get data when selected row
        EventBus.$on("cc-select-link", function(value) {
            _this.setValue(value);
        });
    },
    methods:{
        search:function(){
             var _this = this;
            _this.isDisplay = true;
            common.initFlagCC = false;
            _this.requestSearch = $.extend({}, _this.cc211SearchTdkList);
            EventBus.$emit("event-dataTable"+_this.pageID, _this.requestSearch, undefined, undefined, undefined, 'cc');
        },
        setValue:function(data){
            this.$emit("set-addr-value", data);
            this.showFlg = false;
        },
        /**
         *  Exec close modal
         * @param {Any} evt, event close
         */
        handleCancel(evt){
            evt.preventDefault();
            this.showFlg = false;
        }
    },
    watch: {
        /*
        *  event close modal
        */
       // eslint-disable-next-line
        showFlg(newVal, oldVal) {
            this.$emit('modal-close', 'cc211');
        }
    },
    /*
    * Forcus to input
    */
    updated: function(){
    },

    computed: {
        modalTitle() {
            if (this.listType == '1') {
                //送主一覧
                return this.$t('cc211.labels.title1');
            } else {
                //お届先一覧
                return this.$t('cc211.labels.title');
            }
        }
    },

}
</script>